Ext.define('SA.view.color.PaletteTab', {
    alias: 'widget.palette-tab',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'color-palette',
            margin: '0 6',

            listeners: {
                'select:color': function(view, color) {
                    view.up('[window]').useColor(color);
                }
            }
        }, {
            xtype: 'component',
            cls: 'sa-color-window-separator'
        }, {
            xtype: 'recent-row',
            margin: '0 0 10',

            listeners: {
                'select:recentColor': function(color) {
                    this.up('[window]').useColor(color);
                }
            }
        }
    ]
});